import {PageState} from '../reducers/page.reducer';
import {safelyToJS} from './utils';

export const selectPages = (state): PageState => safelyToJS(state.get('page'));
